export default __webpack_public_path__ + "static/media/competition_bg_footer.3c665220.png";